import _ from "lodash";

declare global {
    interface String {
        truncate(length: number, suffix?: string): string;
    }
    interface StringConstructor {
        isNotEmpty(value: unknown): value is string;
    }
}
String.isNotEmpty = function (value: unknown): value is string {
    return typeof value === "string" && value.trim().length > 0;
}
String.prototype.truncate = function (length: number, suffix: string = "..."): string {
    if (this.length <= length) {
        return String(this);
    }
    return this.slice(0, length - suffix.length) + suffix;
};

declare global {
    interface String {
        /**
         * Formats the string by replacing variables with their values from the context object.
         * Variables in the string should be in the format `${variableName}`.
         * @param context Context object to replace variables in the string.
         * @returns The formatted string with variables replaced.
         */
        substitute<T extends Record<string, any>>(context: T): string;
    }
}
String.prototype.substitute = function <T extends Record<string, any>>(context: T): string {
    return this.replace(/\$\{([\w.]+)\}/g, (_A, k) => _.at(context, k)[0] ?? `\${${k}}`);
};
export default {};